import * as React from "react";

const ExportIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <g fill="none" fillRule="evenodd">
                <g fill="#006AE3" fillRule="nonzero">
                    <g>
                        <g>
                            <path
                                d="M15.397 0h-4.362c-.333 0-.603.27-.603.603 0 .333.27.603.603.603h3.759v3.759c0 .333.27.603.603.603.333 0 .603-.27.603-.603V.603C16 .27 15.73 0 15.397 0z"
                                transform="translate(-463 -556) translate(463 555) translate(0 1)"
                            />
                            <path
                                d="M15.823.177c-.235-.236-.617-.236-.852 0L6.368 8.78c-.236.236-.236.618 0 .853.117.117.271.176.426.176.154 0 .309-.058.426-.176l8.603-8.604c.236-.235.236-.617 0-.852z"
                                transform="translate(-463 -556) translate(463 555) translate(0 1)"
                            />
                            <path
                                d="M13.347 7.497c-.333 0-.603.27-.603.604v6.693H1.206V3.256H7.9c.333 0 .603-.27.603-.603 0-.333-.27-.603-.603-.603H.603C.27 2.05 0 2.32 0 2.653v12.744c0 .333.27.603.603.603h12.744c.333 0 .603-.27.603-.603V8.1c0-.333-.27-.603-.603-.603z"
                                transform="translate(-463 -556) translate(463 555) translate(0 1)"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(ExportIcon);
